<template>
    <div>
      <Terms :visible.sync="dialogVisible"></Terms>
      <div class="info" :style=style>
          <div>OneAD ⓒ {{ thisYear }}. All Rights Reserved / <a style="cursor: pointer;" @click='openTerms'> 使用者條款 / 隱私權政策</a></div>
      </div>
    </div>
</template>

<script>
import Terms from '@/views/terms.vue'
export default {
  components: { Terms },
  name: 'Copyright',
  props: ['color', 'type'],
  data () {
    return {
      dialogVisible: false
    }
  },
  computed: {
    thisYear () {
      return (new Date()).getFullYear()
    },
    style () {
      return {
        'text-align': 'center',
        bottom: '3px',
        width: '100%',
        position: 'fixed',
        'font-size': '12px',
        color: `${this.color ? this.color : 'black'}`,
        opacity: 0.5
      }
    }
  },
  methods: {
    openTerms () {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>
